import React from 'react';
import { string, oneOf, func, node } from 'prop-types';
import { Button } from '../../Atoms/Button';
import { ArticleSnippetWrapper, ButtonWrapper, CenterIfMobile } from './ArticleSnippetV2.styles';
export const ArticleSnippetV2 = _ref => {
  let {
    title,
    textContent,
    btnUrl,
    btnText,
    onClick,
    color,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(ArticleSnippetWrapper, null, /*#__PURE__*/React.createElement(CenterIfMobile, null, title, textContent), /*#__PURE__*/React.createElement(ButtonWrapper, null, btnUrl || onClick ? /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: color,
    size: "extra-large",
    href: btnUrl,
    onClick: onClick
  }, btnText) : null, children || null));
};
ArticleSnippetV2.propTypes = {
  title: node.isRequired,
  textContent: node,
  btnUrl: string,
  btnText: string,
  onClick: func,
  color: oneOf(['blue', 'branded', 'purple', 'pink']),
  children: node
};
ArticleSnippetV2.defaultProps = {
  textContent: null,
  btnUrl: '',
  btnText: '',
  onClick: undefined,
  color: 'blue',
  children: null
};